// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  quoteId: __t.u64().primaryKey().name("quote_id"),
  owner: __t.identity(),
  stationKey: __t.string().name("station_key"),
  role: __t.string(),
  kind: __t.string(),
  version: __t.u32(),
  shipId: __t.u64().name("ship_id"),
  fitRev: __t.string().name("fit_rev"),
  wreckId: __t.u64().name("wreck_id"),
  hpMax: __t.u32().name("hp_max"),
  missingHp: __t.u32().name("missing_hp"),
  restoreHp: __t.u32().name("restore_hp"),
  missiles: __t.u32(),
  counters: __t.u32(),
  parts: __t.u32(),
  source: __t.string(),
  partUnitSov: __t.i64().name("part_unit_sov"),
  partsSov: __t.i64().name("parts_sov"),
  labourSov: __t.i64().name("labour_sov"),
  rearmSov: __t.i64().name("rearm_sov"),
  operatorFeeSov: __t.i64().name("operator_fee_sov"),
  platformFeeSov: __t.i64().name("platform_fee_sov"),
  totalSov: __t.i64().name("total_sov"),
  durationS: __t.u32().name("duration_s"),
  mustered: __t.bool(),
  unitsJson: __t.string().name("units_json"),
  note: __t.string(),
  state: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
